<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  background-color: #f3f5f7;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue